import React from 'react';
import AgentCard from './AgentCard'

const AgentInfoSection = ({ model }) => {
    const service = model.agentInfo?.servicingAgent || {};
    const write = model.agentInfo?.writingAgent || {};
    return (
        <div className="personCardContainer">
            <AgentCard
                title="Writing Agent"
                agent={write}
            />
            {service.name && (
                <AgentCard
                    title="Servicing Agent"
                    agent={service}
                />
            )}
        </div>
    );
};
export default AgentInfoSection;
